class ShippingEstimator extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.countrySelect = this.querySelector('[data-country]');
        this.provinceSelect = this.querySelector('[data-province]');
        this.provinceContainer = this.querySelector('[data-province-container]');
        this.shippingMessage = this.querySelector('[data-shipping-message]');
        this.provinces = [];
        this.zipInput = this.querySelector('[data-zip]');
        this.submitButton = this.querySelector('[data-submit]');
        this.rates = null;
        this.updating = false;
        this.repeatTimer = null;
        if (
            !this.countrySelect ||
            !this.zipInput ||
            !this.provinceSelect ||
            !this.provinceContainer ||
            !this.submitButton ||
            !this.shippingMessage
        ) {
            console.error('Required markup not found.');
            return;
        }

        this.onCountryChangeHandler = this.onCountryChange.bind(this);
        this.onProvinceChangeHandler = this.onProvinceChange.bind(this);
        this.onZipInputHandler = debounce((event) => {
            this.onZipInput(event);
        }, 300).bind(this);
        this.onSubmitHandler = this.onSubmit.bind(this);

        this.countrySelect.addEventListener('change', this.onCountryChangeHandler);
        this.provinceSelect.addEventListener('change', this.onProvinceChangeHandler);
        this.zipInput.addEventListener('keyup', this.onZipInputHandler);
        this.submitButton.addEventListener('click', this.onSubmitHandler);
    }

    disconnectedCallback() {
        this.countrySelect.removeEventListener('change', this.onCountryChangeHandler);
        this.provinceSelect.removeEventListener('change', this.onProvinceChangeHandler);
        this.zipInput.removeEventListener('keyup', this.onZipInputHandler);
        this.submitButton.removeEventListener('click', this.onSubmitHandler);
    }

    onCountryChange(event) {
        if (!event) return;
        this.country = event.target.value;
        this.province = '';
        this.provinces = JSON.parse(
            this.countrySelect.options[this.countrySelect.selectedIndex].getAttribute(
                'data-provinces'
            )
        );
        if (this.provinces.length) {
            this.provinceContainer.classList.remove('hidden');
        } else {
            this.provinceContainer.classList.add('hidden');
        }
        this.generateProvinces();
        this.validateForm();
    }

    onProvinceChange(event) {
        if (!event) return;
        this.province = event.target.value;
        this.validateForm();
    }

    onZipInput(event) {
        if (!event) return;
        this.zip = event.target.value;
        this.validateForm();
    }

    onSubmit() {
        const valid = this.validateForm(true);
        if (!valid) return;
        this.prepareResults();
    }

    // Realistically with the button disabled/enabled automatically we don't ever need to display the erorrs but who knows what might happen - maybe the button somehow gets enabled
    validateForm(displayErrors) {
        let valid = true;
        this.shippingMessage.classList.add('hidden');
        if (!this.country || this.country === '---') {
            valid = false;
            if (displayErrors)
                this.countrySelect.closest('label').classList.add('custom-input--error');
        } else {
            this.countrySelect.closest('label').classList.remove('custom-input--error');
        }
        if (this.provinceSelect.options.length > 1 && !this.province) {
            valid = false;
            if (displayErrors)
                this.provinceSelect.closest('label').classList.add('custom-input--error');
        } else {
            this.provinceSelect.closest('label').classList.remove('custom-input--error');
        }
        if (!this.zip) {
            valid = false;
            if (displayErrors) this.zipInput.closest('label').classList.add('custom-input--error');
        } else {
            this.zipInput.closest('label').classList.remove('custom-input--error');
        }
        this.submitButton.toggleAttribute('disabled', !valid);
        if (displayErrors || valid) this.classList.toggle('shipping-estimator--error', !valid);
        return valid;
    }

    generateProvinces() {
        this.province = '';
        this.provinceSelect.textContent = null;
        const defaultOption = document.createElement('option');
        defaultOption.textContent = window.variantStrings.pleaseSelect;
        defaultOption.setAttribute('selected', true);
        this.provinceSelect.appendChild(defaultOption);
        this.provinces.forEach((province, index) => {
            const option = document.createElement('option');
            option.value = province[0];
            option.textContent = province[1];
            this.provinceSelect.appendChild(option);
        });
    }

    prepareResults() {
        const estimator = this;
        if (this.updating) return;
        this.shippingMessage.classList.add('hidden');
        this.setLoading();

        const postData = {
            shipping_address: {
                zip: this.zip,
                country: this.country,
                province: this.province
            }
        };

        fetch(window.Shopify.routes.root + 'cart/prepare_shipping_rates.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(postData)
        })
            .then((response) => {
                if (!response.ok) {
                    clearTimeout(estimator.repeatTimer);
                    return Promise.reject(new Error(response));
                }
                return response.json();
            })
            .then((data) => {
                estimator.fetchResults(postData);
            })
            .catch((error) => {
                console.error(error);
                estimator.removeLoading();
                estimator.shippingMessage.querySelector('span').textContent =
                    window.variantStrings.shippingUnsupported;
                estimator.shippingMessage.classList.remove('alert-message--success');
                estimator.shippingMessage.classList.add('alert-message--attention');
                this.shippingMessage.classList.remove('hidden');
            });
    }

    fetchResults(postData) {
        const estimator = this;
        clearTimeout(estimator.repeatTimer);
        fetch(window.Shopify.routes.root + `cart/async_shipping_rates.json`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then((response) => {
                if (!response.ok) {
                    return Promise.reject(new Error(response));
                }
                return response.json();
            })
            .then((response) => {
                if (!response) {
                    estimator.repeatTimer = setTimeout(() => {
                        estimator.fetchResults(postData);
                    }, 500);
                    return;
                }
                if (response.shipping_rates && response.shipping_rates.length) {
                    estimator.rates = response.shipping_rates;
                    estimator.displayRate();
                    estimator.shippingMessage.classList.add('alert-message--success');
                    estimator.shippingMessage.classList.remove('alert-message--attention');
                } else {
                    return Promise.reject(new Error(response));
                }
            })
            .catch((error) => {
                console.error(error);
                estimator.shippingMessage.querySelector('span').textContent =
                    window.variantStrings.shippingUnsupported;
                estimator.shippingMessage.classList.remove('alert-message--success');
                estimator.shippingMessage.classList.add('alert-message--attention');
            })
            .finally(() => {
                estimator.removeLoading();
                this.shippingMessage.classList.remove('hidden');
            });
    }

    displayRate() {
        const target = this.shippingMessage.querySelector('span');
        if (target) target.textContent = '';
        this.rates.forEach((rate) => {
            const textElement = document.createElement('span');
            if (rate.price && rate.name && rate.currency) {
                if (rate.price == '0.00') {
                    textElement.textContent = `${window.variantStrings.freeShipping} - ${rate.name}`;
                    target?.appendChild(textElement);
                } else {
                    textElement.textContent = `${rate.currency} ${rate.price} - ${rate.name}`;
                    target?.appendChild(textElement);
                }
            }
        });
        this.shippingMessage.classList.remove('hidden');
    }

    setLoading() {
        this.updating = true;
        this.submitButton.classList.add('loading');
        this.submitButton.querySelector('.loading__spinner').classList.remove('hidden');
    }

    removeLoading() {
        this.updating = false;
        this.submitButton.classList.remove('loading');
        this.submitButton.querySelector('.loading__spinner').classList.add('hidden');
    }
}

customElements.define('shipping-estimator', ShippingEstimator);
